import { useState } from "react";
import { Card, Col, Form, Nav, Row, Tab } from "react-bootstrap";
import { CiMail, CiWallet } from "react-icons/ci";

const SubscriptionSettings = () => {
    const [tabkey, setTabkey] = useState('pill-1');

    return ( <>
    <div className="container-fluid py-3">
        <Tab.Container id="subscription-setting-tab" activeKey={tabkey}>
            <Card body className="mb-3">
                <Card.Subtitle className="fw-semibold mb-3">Settings</Card.Subtitle>
                <Nav variant="pills" className="nav-pills-gray d-inline-flex rounded-2 border border-opacity-75 p-1"
                onSelect={(k) => setTabkey(k)}>
                    <Nav.Item>
                        <Nav.Link eventKey="pill-1" as='button' className='py-1 hstack'>
                            <span className="me-2"><CiWallet size={18} /></span>
                            <span>Payment Gateways</span>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="pill-2" as='button' className='py-1 hstack'>
                            <span className="me-2"><CiMail size={18} /></span>
                            <span>Email Template</span>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </Card>
            <Tab.Content>
                {tabkey === 'pill-1' && (
                <Tab.Pane eventKey="pill-1">
                    <Card body>
                        <Card.Subtitle className="fw-semibold mb-3">Stripe</Card.Subtitle>
                        <Row className="g-3 mt-1">
                            <Col xs={12} sm={6} md={5}>
                                <Form.Group controlId="api-key" className="form-label-group in-border">
                                    <Form.Control name="api-key" placeholder="API Key" 
                                    defaultValue={'sk_test_'} />
                                    <Form.Label>API Key</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6} md={5}>
                                <Form.Group controlId="webhook-secret" className="form-label-group in-border">
                                    <Form.Control name="webhook-secret" placeholder="Webhook Secret" 
                                    defaultValue={'2whsec_..'} />
                                    <Form.Label>Webhook Secret</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="w-100 mt-0">
                                <Form.Check className="fs-6 text-secondary"
                                    type='checkbox'
                                    id={`enable-stripe-payment-check`}
                                    label={`Enable Stripe Payment`}
                                />
                            </Col>
                        </Row>
                    </Card>
                    <Card body className="mt-3">
                        <Card.Subtitle className="fw-semibold mb-3">Razor Pay</Card.Subtitle>
                        <Row className="g-3 mt-1">
                            <Col xs={12} sm={6} md={5}>
                                <Form.Group controlId="key-id" className="form-label-group in-border">
                                    <Form.Control name="key-id" placeholder="Key ID" 
                                    defaultValue={'rzp_test_'} />
                                    <Form.Label>Key ID</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6} md={5}>
                                <Form.Group controlId="key-secret" className="form-label-group in-border">
                                    <Form.Control name="key-secret" placeholder="Key Secret" 
                                    defaultValue={'2whsec_..'} />
                                    <Form.Label>Key Secret</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="w-100 mt-0">
                                <Form.Check className="fs-6 text-secondary"
                                    type='checkbox'
                                    id={`enable-razor-payment-check`}
                                    label={`Enable Razor Payment`}
                                />
                            </Col>
                        </Row>
                    </Card>
                </Tab.Pane>
                )}
                {tabkey === 'pill-2' && (
                <Tab.Pane eventKey="pill-2">
                    <Card body>
                        <Card.Subtitle className="fw-semibold mb-3">Welcome Email</Card.Subtitle>
                        <Row className="g-3 mt-1">
                            <Col xs={12} sm={6} md={5}>
                                <Form.Group controlId="welcome-mail-subject" className="form-label-group in-border">
                                    <Form.Control name="welcome-mail-subject" placeholder="Welcome to DigiHRMS" 
                                    defaultValue={'Welcome to DigyHRMS'} />
                                    <Form.Label>Subject</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group controlId="wecome-mail-content" className="form-label-group in-border">
                                    <Form.Control name="wecome-mail-content" as={"textarea"} rows={3}
                                    placeholder="Content" defaultValue={'Dear.....'} />
                                    <Form.Label>Content</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card>
                    <Card body className="mt-3">
                        <Card.Subtitle className="fw-semibold mb-3">Invoice Email</Card.Subtitle>
                        <Row className="g-3 mt-1">
                            <Col xs={12} sm={6} md={5}>
                                <Form.Group controlId="invoice-mail-subject" className="form-label-group in-border">
                                    <Form.Control name="invoice-mail-subject" placeholder="Welcome to DigiHRMS" 
                                    defaultValue={'Welcome to DigyHRMS'} />
                                    <Form.Label>Subject</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group controlId="invoice-mail-content" className="form-label-group in-border">
                                    <Form.Control name="invoice-mail-content" as={"textarea"} rows={3}
                                    placeholder="Content" defaultValue={'Dear.....'} />
                                    <Form.Label>Content</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card>
                </Tab.Pane>
                )}
            </Tab.Content>
        </Tab.Container>
    </div>
    </> );
}
 
export default SubscriptionSettings;